import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import DsraEventListUI from './DsraEventListUI.js'

class DsraEventListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      dsraEventList: null,
      dsraEventListUpdated: false
    }
  }

  render() {
    return (
      <DsraEventListUI
        context={this.props.context}
        account={this.props.account}
        loan={this.props.loan}
        errorList={this.state.errorList}
        dsraEvent={this.state.dsraEvent}
        dsraEventList={this.state.dsraEventList}
        onRefreshClick={this.onRefreshClick}
        dsraEventListUpdated={this.state.dsraEventListUpdated}
        onDsraEventListUpdateClick={() => { this.setState({ dsraEventListUpdated: true }) }}
        onDsraEventListCancelClick={() => { this.setState({ dsraEventListUpdated: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDsraEvents(context)
  }

  getDsraEvents(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.loan.accountId}/dsraEvents`,
      cacheKey: CacheKeys.DsraEvents(this.props.loan.accountId),
      callback: this.getDsraEventsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDsraEventsCallback = (response) => {
    let dsraEvent = response
    this.setState({ errorList: response.errorList, dsraEventList: response.dsraEventList, dsraEvent: dsraEvent })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.DsraEvents(this.props.loan.accountId))
    this.setState(
      {
        errorList: null,
      }, this.getDsraEvents(this.props.context)
    )
  }

}

export default DsraEventListSF
